module.exports = __webpack_public_path__ + "056ea02f7ddcbbd0850c4e99a564db2f.svg";